(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ContactForCustomer', ContactForCustomer);

    ContactForCustomer.$inject = ['$resource'];
    function ContactForCustomer ($resource) {
        var resourceUrl =  'api/contacts/customer/:customerId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

})();
